import React, { useState } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Link } from "react-router-dom";
import faqBanner from "../../Images/student-services/ragging.webp";
import classroomImage from "../../Images/gov-body/rules.webp";
import { Row, Col, Accordion } from "react-bootstrap";

const clubList = [
    {
        title: "Ragging",
        icon: "ti ti-user-off", // symbolizes blocked/removed user
        bg: "bg-white"
    },
    {
        title: "Alcohol, Smoking, Gambling",
        icon: "ti ti-smoking", // clear and relevant
        bg: "bg-white"
    },
    {
        title: "Misconduct, Hooliganism, Indiscipline",
        icon: "ti ti-alert-triangle", // caution/exclamation
        bg: "bg-white"
    },
    {
        title: "Possession or use of firearms or any lethal weapon",
        icon: "ti ti-target-arrow", // weapon icon available
        bg: "bg-white"
    },
    {
        title: "Possession or use of addictive or hallucinogenic drugs in the campus",
        icon: "ti ti-capsule", // pill/capsule
        bg: "bg-white"
    },
    {
        title: "Possession or use of alcoholic beverages or delinquency under the influence of alcohol",
        icon: "ti ti-beer", // beer/mug icon
        bg: "bg-white"
    }
];

const RaggingPolicy = () => {
    return (
        <>
            <title>ISBM University Anti-Ragging Policy | Promoting Student Safety</title>
            <meta
                name="description"
                content="ISBM University enforces a strict anti-ragging policy to ensure a safe and respectful campus environment for all students. Know our policies & stay protected today!"
            />
            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${faqBanner})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="container-xxl">
                        <div className="section-hero-content">
                            <h1>Anti-Ragging Policy</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <Link to="/" style={{ color: "#fff", textDecoration: "none" }}>
                                        Home
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active text-white" aria-current="page">
                                    Anti-Ragging Policy
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-xxl ptb-50">
                    <Row className="m-0">
                        <div className="col-md-6">
                            <div className="governing-image-wrapper shadow">
                                <img src={classroomImage} alt="Person holding documents at a desk" />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <h2 className="modern-title text-blue">Anti-Ragging Policy</h2>
                            <div className="underline-divider mb-3"></div>
                            <p className="text-muted">
                                Student found guilty of such act by the way of including in or outside the premises of the University shall be liable to punishment as per the guidelines given by UGC in the light of the direction of Hon'ble Supreme Court depending upon the natural gravity of the offence establish by Anti Ragging Committe of the University. The punishment for those found guilty of the ragging at the University level shall be any one or any combination of the following:
                            </p>
                            <ul className="list-disc ps-4 leading-relaxed">
                                <li>Suspension from attending classes and academic privileges</li>
                                <li>Withholding/withdrawing scholarship, fellowship and other benefits</li>
                                <li>Debarring from appearing in any test, examination or other evaluation process</li>
                                <li>Withholding results</li>
                                <li>Debarring from representing the institute in any regional, national or international meet, tournament, youth festival etc.</li>
                                <li>Suspension/expulsion from the hostel</li>
                                <li>Cancellation of admission</li>
                                <li>Rustication from the institute for a period ranging from 1 to 4 semesters</li>
                                <li>Fine ranging from ₹25,000/- to ₹1,00,000/-</li>
                                <li>
                                    Collective punishment: When the persons committing or abetting the crime of ragging are not identified,
                                    the institution shall resort to collective punishment.
                                </li>
                            </ul>
                        </div>
                    </Row>
                </div>
            </section>

            <section className="visa-section py-5 bg-light">
                <div className="container-xxl">
                    <div className="row g-4">
                        {clubList.map((club, index) => (
                            <div className="col-lg-4 col-12" key={index}>
                                <div className={`innovation-card h-100 ${club.bg}`}>
                                    <div className="innovation-icon">
                                        <i className={club.icon}></i>
                                    </div>
                                    <h3 className="fw-bold mb-3">{club.title}</h3>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="ptb-50 color-section">
                <div className="container-xxl">
                    <Row>
                        <Col lg={12} className="text-justify">
                            <p>
                                <b>STUDENTS DISCIPLINE:</b>
                            </p>
                            <p>
                                Students enrolled in the University must recognize their
                                responsibilities towards the faculty, office staff and
                                fellow students by maintaining appropriate standards of
                                conduct, failing which may attract disciplinary
                                action.
                            </p>
                            <p>
                                The University believes that duty, decorum and
                                discipline are the hallmarks of a good student. Students
                                with such qualities alone can prove to be productive
                                manpower with appreciable value systems. Therefore,
                                erring students would be subject to certain disciplinary
                                code. The following acts would be deemed as acts of
                                indiscipline: Any overt or covert act leading to
                                ragging, eve teasing, disruption of classroom
                                activities, disturbing the studies of other students,
                                marring the operations of the University, harming the
                                health or safety of staff or students, damaging
                                property, possession of intoxicants, illicit drugs or
                                weapons on campus, misconduct during examinations,
                                submitting false documents for admission, and failure to
                                return loaned materials or settle dues with ISBM
                                University.
                            </p>

                            <p><b>RULES & REGULATIONS</b></p>
                            <ul className="list-disc ps-4 leading-relaxed">
                                <li>
                                    If an applicant is found ineligible for admission at
                                    any stage, their eligibility shall stand cancelled. If
                                    detected later, the disqualification will take effect
                                    retrospectively, and no claim shall be entertained
                                    against ISBM University.
                                </li>
                                <li>
                                    Students must produce their original certificates for
                                    verification when requested. If documents are found
                                    fake or fraudulent, the admission will be cancelled,
                                    and no degree will be awarded.
                                </li>
                                <li>
                                    Degrees/Diplomas/Certificates will be awarded only if
                                    students acquire passing grades in all semesters
                                    within the maximum course duration.
                                </li>
                                <li>
                                    Students failing to complete all exams within the
                                    stipulated duration will not be awarded their degree,
                                    and no fees will be refunded.
                                </li>
                                <li>
                                    Students may discontinue their studies at any time,
                                    but fees paid will not be refunded.
                                </li>
                                <li>
                                    ISBM University reserves the right to update or modify
                                    the syllabus/content without prior notice.
                                </li>
                                <li>
                                    If a student is found violating rules or concealing
                                    facts, their admission may be terminated without
                                    refund. Legal jurisdiction will be Gariyaband, Raipur.
                                </li>
                            </ul>
                        </Col>
                    </Row>
                </div>
            </section>

            <Footer />
        </>
    );
};

export default RaggingPolicy;
